import {
  POWER_REVIEWS_API_KEY,
  POWER_REVIEWS_MERCHANT_GROUP_ID,
  POWER_REVIEWS_MERCHANT_ID,
} from '../app';

// eslint-disable-next-line import/prefer-default-export
export const POWER_REVIEWS_CONFIG = {
  ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
  api_key: POWER_REVIEWS_API_KEY,
  locale: 'en_US',
  merchant_group_id: POWER_REVIEWS_MERCHANT_GROUP_ID,
  merchant_id: POWER_REVIEWS_MERCHANT_ID,
  enable_content_collection_modal: false,
};
